import React, { useMemo, useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { companyInfo, productShowcase } from "@/data/mock";
import PackagingPlaceholder from "./PackagingPlaceholder";

export default function ProdukKamiSection() {
  const openWA = (text = "") => {
    const url = `https://wa.me/${companyInfo.whatsapp}${
      text ? `?text=${encodeURIComponent(text)}` : ""
    }`;
    window.open(url, "_blank");
  };

  const isGramasiBadge = (badge) => {
    if (!badge) return false;
    return /\b\d+\s*(g|gr|kg)\b/i.test(String(badge));
  };

  const packagingPriority = (p) => {
    const v = (p?.packaging || "").toLowerCase();
    if (v.includes("botol")) return 0;          // botol sejajar dulu
    if (v.includes("sachet")) return 1;
    if (v.includes("standing")) return 2;
    return 9;
  };

  // 1) filter hidden, 2) dedup name+packaging, 3) sort (botol sejajar)
  const baseProducts = useMemo(() => {
    const list = Array.isArray(productShowcase) ? productShowcase : [];
    const visible = list.filter((p) => !p?.hidden);

    const map = new Map();
    for (const p of visible) {
      const name = (p?.name || "").trim();
      const packaging = (p?.packaging || "").trim();
      const key = `${name}__${packaging}`;

      if (!map.has(key)) {
        map.set(key, p);
        continue;
      }

      // prefer yang punya image
      const exist = map.get(key);
      if (!exist?.image && p?.image) map.set(key, p);
    }

    const arr = Array.from(map.values());
    arr.sort((a, b) => {
      const pa = packagingPriority(a);
      const pb = packagingPriority(b);
      if (pa !== pb) return pa - pb;
      return (a.name || "").localeCompare(b.name || "");
    });

    return arr;
  }, []);

  const filters = useMemo(() => {
    const unique = Array.from(new Set(baseProducts.map((p) => p.packaging).filter(Boolean)));
    const order = ["Botol", "Sachet", "Standing Pouch"]; // biar botol bareng
    const sorted = order.filter((x) => unique.includes(x)).concat(unique.filter((x) => !order.includes(x)));
    return ["Semua", ...sorted];
  }, [baseProducts]);

  const [activeFilter, setActiveFilter] = useState("Semua");

  const filteredProducts = useMemo(() => {
    if (activeFilter === "Semua") return baseProducts;
    return baseProducts.filter((p) => p.packaging === activeFilter);
  }, [activeFilter, baseProducts]);

  return (
    <section id="produk" className="products-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Produk Kami</span>
          <h2 className="section-title">
            Koleksi Produk <br />
            <span className="text-accent">Bumbu & Rempah SHAKTI</span>
          </h2>
          <p className="section-description">
            Produk ditampilkan tanpa variasi gramasi (sesuai revisi). Untuk detail gramasi & kebutuhan, silakan hubungi tim kami.
          </p>
        </div>

        {/* FILTER BUTTONS */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {filters.map((f) => {
            const active = activeFilter === f;
            return (
              <Button
                key={f}
                variant={active ? "default" : "outline"}
                onClick={() => setActiveFilter(f)}
                className={
                  active
                    ? "bg-[#a00e21] hover:bg-[#8b0c1c] text-white"
                    : "border-[#a00e21]/30 text-[#a00e21] hover:border-[#a00e21]"
                }
                size="sm"
              >
                {f}
              </Button>
            );
          })}
        </div>

        <div className="products-grid">
          {filteredProducts.map((product) => {
            const showBadge = !!product.badge && !isGramasiBadge(product.badge);

            return (
              <Card key={product.id} className="product-card">
                <div className="product-image-wrapper">
                  {product.image ? (
                    <img
                      src={encodeURI(product.image)}
                      alt={product.name}
                      className="product-image"
                    />
                  ) : (
                    <PackagingPlaceholder
                      title={product.name}
                      badge={product.badge || "New"}
                      className="product-image"
                    />
                  )}

                  <div className="product-overlay">
                    <Button
                      onClick={() =>
                        openWA(
                          `Halo, saya tertarik dengan produk ${companyInfo.brand}: ${product.name}. Mohon info katalog & harga.`
                        )
                      }
                      className="overlay-button"
                      size="sm"
                    >
                      Tanya Produk
                    </Button>
                  </div>
                </div>

                <CardContent className="product-content">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>

                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>

                    {!!product.packaging && (
                      <span
                        style={{
                          fontSize: 12,
                          padding: "4px 10px",
                          borderRadius: 999,
                          border: "1px solid rgba(160,14,33,0.25)",
                          color: "#a00e21",
                          fontWeight: 900,
                          background: "rgba(160,14,33,0.04)",
                        }}
                      >
                        {product.packaging}
                      </span>
                    )}
                     {!!product.tags?.length && (
                    <div >
                      {product.tags.map((t) => (
                        <span
                          key={t}
                          style={{
                            fontSize: 12,
                            padding: "4px 10px",
                            borderRadius: 999,
                            border: "1px solid rgba(160,14,33,0.25)",
                            color: "#a00e21",
                            fontWeight: 800,
                          }}
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  )}
                  </div>

                 
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
